import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import RichText from '../rich-text';
import ImageSlice from '../image';

type ImageTextProps = {
  reverse?: boolean;
};

export const ImageText = styled.section<ImageTextProps>(
  props => css`
    display: flex;
    flex-wrap: nowrap;
    flex-direction: ${props.reverse ? 'row-reverse' : 'row'};

    > * {
      flex-grow: 1;
      width: 50%;
    }

    ${media.smallOnly`
      flex-direction: ${props.reverse ? 'column-reverse' : 'column'};
    `};
  `
);

type SharedProps = {
  width: string;
  reverse: boolean;
};

export const Text = styled(RichText)<SharedProps>(
  props => css`
    width: ${props.width};
    padding-left: ${!props.reverse ? layout.spacing.small : 0};
    padding-right: ${props.reverse ? layout.spacing.small : 0};

    ${media.smallOnly`
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-top: ${!props.reverse ? layout.spacing.small : 0};
      padding-bottom: ${props.reverse ? layout.spacing.small : 0};
    `};
  `
);

export const Image = styled(ImageSlice)<SharedProps>(
  props => css`
    width: ${props.width};
    padding-left: ${props.reverse ? layout.spacing.small : 0};
    padding-right: ${!props.reverse ? layout.spacing.small : 0};

    ${media.smallOnly`
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-top: ${props.reverse ? layout.spacing.small : 0};
      padding-bottom: ${!props.reverse ? layout.spacing.small : 0};
    `};
  `
);
